import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import Link from 'next/link';
import React, { memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ImageBlock = ({ route, image, imageWebp = '', name }) => {
    const WrapLink = ({ children }) => {
        return route ? <Link passHref href={route}>{children}</Link> : <>{children}</>;
    };

    return (
        <WrapLink>
            <a title={name} data-test='router-item-img'>
                <WebpImage urlWebp={imageWebp}>
                    <LazyLoadImage src={image} alt={name}/>
                </WebpImage>
            </a>
        </WrapLink>
    );
};

export default memo(ImageBlock);
